import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import VueI18n from 'vue-i18n';
import VueApexCharts from 'vue-apexcharts';
import i18n from './i18n'; // import your i18n instance

Vue.use(VueApexCharts);

Vue.use(Vuetify);
Vue.use(VueI18n);

Vue.component('apexchart', VueApexCharts);

export default new Vuetify({
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 540,
      md: 800,
      lg: 1280,
    },
    scrollBarWidth: 24,
  },
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#007BFF',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        background: '#F5F5F5',
        surface: '#FFFFFF',
      },
      dark: {
        // primary: colors.blue.lighten3,
      },
    },
  },

});
